import { render, staticRenderFns } from "./importDetailProduct.vue?vue&type=template&id=b195992a&scoped=true&"
import script from "./importDetailProduct.vue?vue&type=script&lang=js&"
export * from "./importDetailProduct.vue?vue&type=script&lang=js&"
import style0 from "./importDetailProduct.vue?vue&type=style&index=0&id=b195992a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b195992a",
  null
  
)

export default component.exports